import React from "react";
import { GoToTop } from "../../pages/Talk";
import clsx from "clsx";

type Props = {
  scrollDivRef: React.RefObject<HTMLDivElement>;
  wrapperClassName?: string;
};

export default function useToTop({ scrollDivRef, wrapperClassName }: Props) {
  return (
    <div
      className={clsx([
        "fixed bottom-24 right-5 flex flex-col gap-2.5 z-20",
        wrapperClassName,
      ])}
    >
      <div
        className="border border-brand-floating-secondary-button rounded-[10px] p-2 bg-white"
        onClick={() => {
          scrollDivRef.current?.scrollIntoView({ behavior: "smooth" });
        }}
        style={{ boxShadow: "2px 5px 4px 0px rgba(0, 0, 0, 0.10)" }}
      >
        <GoToTop />
      </div>
    </div>
  );
}
